import { render, staticRenderFns } from "./OrderConfirmDialog.vue?vue&type=template&id=f71af068&scoped=true"
import script from "./OrderConfirmDialog.vue?vue&type=script&lang=js"
export * from "./OrderConfirmDialog.vue?vue&type=script&lang=js"
import style0 from "./OrderConfirmDialog.vue?vue&type=style&index=0&id=f71af068&prod&lang=scss&scoped=true"
import style1 from "./OrderConfirmDialog.vue?vue&type=style&index=1&id=f71af068&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f71af068",
  null
  
)

export default component.exports